export enum PrepDetailsActionTypes {
  SET_PREP_DETAILS = "SET_PREP_DETAILS",
  SET_SELECTED_JOB_DETAILS = "SET_SELECTED_JOB_DETAILS",
  SET_SOURCE_PLAN_DETAILS = "SET_SOURCE_PLAN_DETAILS",
  SET_SOURCE_ORDER_DETAILS = "SET_SOURCE_ORDER_DETAILS",
  RESET_DETAILS = "RESET_DETAILS",
  RESET_DETAILS_WITH_ARCHIVED = "RESET_DETAILS_WITH_ARCHIVED",
  SET_PRICING_ERROR = "SET_PRICING_ERROR",
}
